export { default as Accordion } from './accordion'



// WEBPACK FOOTER //
// ./src/components/accordion/index.js